import React from "react";
import { GetUrlLink } from "../utility";

const NotFoundPage = ({ location, history }) => {
  let path = "";
  if (location.pathname && location.search) {
    console.log(location);
    path = `${location.pathname}${location.search.split("?").join("")}`;
    if (path.includes("&")) {
      path = path.split("&")[0];
    }
    history.push(path);
  } else if (location.pathname.includes("/a/")) {
    const sections = localStorage.getItem("sections");
    if (sections) {
      const ParsedData = JSON.parse(sections);
      const urlStr = location.pathname.replace("/a/", "");
      const Filtersection = ParsedData.find(
        (section) => GetUrlLink(section.Group_Name.toLowerCase()) === urlStr
      );
      if (Filtersection) {
        path = `/articles/sections/${GetUrlLink(
          Filtersection.Group_Name.toLowerCase()
        )}/${Filtersection.GroupID}`;
        history.push(path);
      }
    }
  } else if (location.pathname.includes("NewAgeIslamSubscribe.aspx")) {
    history.push("/subscribe");
  } else if (location.pathname.includes("NewAgeIslamUnSubscribe.aspx")) {
    history.push("/unsubscribe");
  }
  return <h1> Page Not Found</h1>;
};

export default NotFoundPage;
